import React from 'react'
import Hero3D from '../components/home/Hero3D'
import DimensionShowcase from '../components/home/DimensionShowcase'
import SupportMatrix from '../components/home/SupportMatrix'
import { Card } from '../components/ui/Card'

export default function HomePage() {
  return (
    <div className="page-stack">
      <Hero3D />
      <DimensionShowcase />
      <SupportMatrix />
      <section className="grid cols-3">
        <Card>
          <span className="eyebrow">BNCC do 1º ao 9º</span>
          <h3>Competências e habilidades por série.</h3>
          <p>O portal organiza a matemática do ensino fundamental 1 e 2 com base em competências, habilidades e conteúdos distribuídos por ano escolar.</p>
        </Card>
        <Card>
          <span className="eyebrow">4 dimensões do mesmo conteúdo</span>
          <h3>Regular, adaptado, blocos e games.</h3>
          <p>O mesmo tema aparece em matemática regular, ensino adaptado com ABA e material dourado, programação em blocos e games em JavaScript.</p>
        </Card>
        <Card>
          <span className="eyebrow">Professor cria mais exercícios</span>
          <h3>Além dos 12 propostos.</h3>
          <p>Há geração de novos exercícios por conteúdo e série, com uso de créditos, histórico de solicitações e editores para resolver cada trilha.</p>
        </Card>
      </section>
    </div>
  )
}
